module.exports = __webpack_public_path__ + "static/media/play.a1c0c32c.svg";